import {connect, useDispatch} from "react-redux";
import {companySectors} from "../../../app/config";
import {
    fetchComplains,
    sendAgainToCompany,
    setFilter,
    uncheckAllItems,
    sendBulkAgainToCompany
} from "../../../app/slices/complainsSlice";
import {FilterMenu} from "../../filterMenu";
import {ScreenHeader} from "../../screenHeader";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {fetchComplainTypes} from "../../../app/slices/complainTypesSlice";
import classNames from "classnames";
import {showModal} from "../../../app/slices/modalSlice";
import _ from "lodash";
import MergeComplainsModal from "../../modal/mergeComplainsModal";
import useSectors from "../../../hooks/useSectors";
import {apiClient} from "../../../providers/apiClient";
import ComplaintService from "../../services/ComplaintService";

function CompanyComplainsTableFilter({   companyId,
                                         filter,
                                         setFilter,
                                         hideSearch,
                                         hideTitle,
                                         listTitle,
                                         selectedItems, 
                                         onMergeFinished
                                    }) {
    const dispatch = useDispatch();
    const {t} = useTranslation('ComplainsScreen', {keyPrefix: 'TableFilter'});
    const {t: t_common} = useTranslation('Common');
    const {t: t_modals} = useTranslation('Modals', {keyPrefix: 'Complaints'});
    const { appSectors, getTypesBySector } = useSectors();
    const [selectedSectorTypes, setSelectedSectorTypes] = useState([]);
    
    
    useEffect(() => {
        if(!filter.sectorId) {
            setSelectedSectorTypes([])
            return;
        }

        getTypesBySector(filter.sectorId).then(types => {
            setSelectedSectorTypes(types);
        })
        
    }, [filter.sectorId]);

    const [showMergeModal, setShowMergeModal] = useState(false);


    const handleFilterChange = (field, value) => {
        setFilter(field, value?.value ?? value);
    };

    const handleSectorChange = (field, value) => {
        if(value === null) {
            setFilter("typeId", null);
        }
        
        setFilter(field, value?.value ?? value);
    }

    const handleDownloadCsv = async () => {
        await ComplaintService.downloadCsvReport(filter);
    }

    const handleMergeSelectedComplains = () => {
        if (!selectedItems || selectedItems.length <= 1) {
            dispatch(showModal({
                title: t_modals('NoSelectionTitle'),
                message: t_modals('NoSelectionMessage'),
                mode: 'danger',
            }));

            return;
        }

        if (!_.every(selectedItems, {mergeInfo: selectedItems[0].mergeInfo})) {
            dispatch(showModal({
                title: t_modals('InvalidSelectionTitle'),
                message: t_modals('InvalidSelectionMessage'),
                mode: 'danger',
            }));

            return;
        }

        setShowMergeModal(true);
    }

    const onMergeModalComplete = async (isSuccess) => {
        setShowMergeModal(false);

        if (isSuccess) {
            dispatch(showModal({
                title: t_modals('MergeSuccess'),
                mode: 'normal',
            }));

            onMergeFinished();
            
        } else {
            dispatch(showModal({
                title: t_modals('MergeError'),
                mode: 'danger',
            }));
        }
    }

    const handleSendAgainBulkToCompany = async () => {
        if (!selectedItems || selectedItems.length < 1) {
            dispatch(showModal({
                message: t_modals('MergeSelectMinOne'),
                mode: 'danger',
            }));
            return;
        }

        let ids = selectedItems.map(item => item.id);
        let result = await dispatch(sendBulkAgainToCompany(ids));

        if (!result.hasOwnProperty('error')) {
            dispatch(showModal({
                title: t_modals('ResendManySuccess'),
                mode: 'normal',
            }));
        } else {
            dispatch(showModal({
                title: t_modals('ResendManyError'),
                mode: 'danger',
            }));
        }
    }


    const handleSendAgainToCompany = async () => {
        if (!selectedItems || selectedItems.length !== 1) {
            dispatch(showModal({
                message: t_modals('MergeSelectOne'),
                mode: 'danger',
            }));

            return;
        }

        let result = await dispatch(sendAgainToCompany(selectedItems[0].id));

        if (!result.hasOwnProperty('error')) {
            dispatch(showModal({
                title: t_modals('ResendSuccess'),
                mode: 'normal',
            }));
        } else {
            dispatch(showModal({
                title: t_modals('ResendError'),
                mode: 'danger',
            }));
        }
    }

    return (
        <>
            {!hideTitle &&
                <ScreenHeader withSearch={!hideSearch} search={filter.search}
                              onChange={(event) => handleFilterChange('search', event.target.value)}/>
            }
            <div className={classNames('fk-filter-container', {'--only-filter': !listTitle,})}>
                <h3>{listTitle}</h3>
                <div className="fk-filter">
                    <FilterMenu
                        label={t('sector.text')}
                        options={appSectors}
                        selected={appSectors.find(i => i.value === filter.sectorId)}
                        onChange={(option) => handleSectorChange('sectorId', option)}
                    />
                    {selectedSectorTypes.length > 0 &&
                        <FilterMenu
                            label={t('type.text')}
                            options={selectedSectorTypes}
                            selected={selectedSectorTypes.find(i => i.value === filter.typeId)}
                            onChange={(option) => handleFilterChange('typeId', option)}
                        />
                    }
                    <FilterMenu
                        actionButton
                        buttonText={t('mergeSelectedComplains')}
                        onClick={handleMergeSelectedComplains}
                    />
                    <FilterMenu
                        actionButton
                        buttonText={t('sendAgain')}
                        onClick={handleSendAgainBulkToCompany}
                    />
                    <FilterMenu
                        actionButton
                        onClick={handleDownloadCsv}
                        buttonText={t_common('downloadCsv')}
                    />
                </div>
            </div>
            <MergeComplainsModal
                show={showMergeModal}
                complains={selectedItems}
                fallback={onMergeModalComplete}
                onCancel={() => setShowMergeModal(false)}
            />
        </>
    );
}

export default CompanyComplainsTableFilter;